<template>
  <div class="card mb-4 shadow-sm border-radius-xl">
    <div class="card-header pb-0 bg-transparent border-bottom-0">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="font-weight-bolder mb-0 text-uppercase">
            <font-awesome-icon icon="cog" class="text-primary me-2" />
            Configuración del Sistema
          </h6>
          <p class="text-sm mb-0">Administrá los proveedores de SMS y sus credenciales</p>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <div class="row">
        <div class="col-lg-5 col-md-12">
          <div class="card bg-gray-100 border-radius-lg p-3 mb-4">
            <div class="form-group mb-3">
              <label class="form-control-label text-uppercase text-xs">Proveedor de SMS</label>
              <select class="form-control bg-white" v-model="config.sms_supplier">
                <option value="">Seleccioná una opción</option>
                <option value="zadarma">ZADARMA</option>
                <option value="aws">AWS (Amazon SNS)</option>
                <option value="infobit">INFOBIT</option>
              </select>
            </div>
            <div class="form-group mb-3">
              <label class="form-control-label text-uppercase text-xs">Access Key ID (AWS)</label>
              <input class="form-control bg-white" placeholder="Ingresá la Access Key" v-model="config.access_key_id">
            </div>
            <div class="form-group mb-3">
              <label class="form-control-label text-uppercase text-xs">Secret Access Key (AWS)</label>
              <input class="form-control bg-white" placeholder="Ingresá la Secret Key" v-model="config.secret_access_key">
            </div>
            <div class="form-group mb-3">
              <label class="form-control-label text-uppercase text-xs">Región (AWS)</label>
              <input class="form-control bg-white" placeholder="Ej: us-east-1" v-model="config.region">
            </div>
            <button class="btn bg-gradient-success w-100 mb-0" @click="saveConfig">
              <font-awesome-icon icon="save" class="me-1" />
              Guardar Configuración
            </button>
          </div>
        </div>
        <div class="col-lg-7 col-md-12">
          <div class="table-responsive">
            <table class="table align-items-center mb-0">
              <thead>
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Proveedor</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Access ID</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Región</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Estado</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, key) in arrayKeys" :key="key">
                  <td class="align-middle px-3">
                    <p class="text-uppercase text-xs font-weight-bold mb-0 text-primary">{{item.sms_supplier}}</p>
                  </td>
                  <td class="align-middle px-3">
                    <p class="text-xs font-weight-bold mb-0 text-truncate" style="max-width: 100px;">{{item.access_key_id}}</p>
                  </td>
                  <td class="align-middle px-3">
                    <p class="text-xs font-weight-bold mb-0">{{item.region || '-'}}</p>
                  </td>
                  <td class="align-middle text-center">
                    <span class="badge badge-sm" :class="item.status ? 'bg-gradient-success' : 'bg-gradient-secondary'">
                      {{ item.status ? 'ACTIVO' : 'INACTIVO' }}
                    </span>
                  </td>
                  <td class="align-middle text-center">
                    <button v-if="!item.status" class="btn btn-link text-info text-gradient px-3 mb-0" @click="setKeys(item)">
                      <font-awesome-icon icon="check" class="me-1" />
                      Activar
                    </button>
                    <span v-else class="text-xs text-success font-weight-bold">En uso</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog, faSave, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faCog, faSave, faCheck);

export default {
  name: "Configuration",
  components: {
    FontAwesomeIcon
  },
  data: () => ({
    arrayKeys: [],
    config: {
      sms_supplier: "",
      access_key_id: "",
      secret_access_key: "",
      region: "",
    },
  }),
  mounted() {
    this.getConfig();
  },
  methods: {
    async saveConfig() {
      await post("general-config/create", this.config);
      await this.getConfig()
      this.config = {
        sms_supplier: "",
        access_key_id: "",
        secret_access_key: "",
        region: "",
      }
      this.$swal({
        html: '¡Configuración guardada correctamente!',
        icon: 'success',
        timer: 2000,
        showCancelButton: false,
        showConfirmButton: false,
      });
    },

    async getConfig() {
      const { data } = await get("general-config");
      if (data) {
        this.arrayKeys = data
      }
    },
    async setKeys(item){
      await post("general-config/update",{_id:  item._id});
      await this.getConfig()
    }
  }
}
</script>

<style scoped>

</style>
